export const KEY = 'corpCode';
